export default function TransactionCellSkeleton() {
  return (
    <div className="flex h-[72px] items-center gap-[12px] p-[14px_16px] bg-white/10 backdrop-blur-[14px] rounded-[16px] animate-pulse"></div>
  );
}
